import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { Provider } from 'react-redux';
import { connect } from 'react-redux';
import { hideLegacyDialog } from '../store/actions';
import { ThemeProvider } from 'dlweb-components';
import Modals from '../components/modals';
import LegacyDialog from '../components/LegacyDialog';

const LegacyDialogRoot = ({ store, $rootScope, hideLegacyDialog, dialogType, dialogProps, dialogContentProps = {} }) => {

  const [open, setOpen] = useState(false);

  const openModal = useCallback(() => setOpen(true), []);
  const closeModal = useCallback(() => { setOpen(false); }, []);
  
  useEffect(() => {
    dialogType ? openModal() : closeModal();
  }, [dialogType, openModal, closeModal]);

  const modalOptions = useMemo(() => ({
    open,
    onOk: closeModal,
    onCancel: closeModal,
    afterClose: hideLegacyDialog,
    destroyOnClose: true,
    forceRender: true,
    maskClosable: false,
    footer: null,
  }), [open, closeModal, hideLegacyDialog]);

  dialogContentProps.workingFolder = $rootScope.workingFolder;

  const mergedModalProps = { ...dialogProps };

  const ctx = { ...dialogProps, ...dialogContentProps, workingFolder: $rootScope.workingFolder };
  // const cfg = useMemo(() => resolveDialog(dialogType, ctx), [dialogType, ctx]);
  // console.log("LegacyDialogRoot render", { cfg, ctx });
  return (
    <Provider store={store}>
      <ThemeProvider>
        <LegacyDialog
          {...modalOptions}
          {...mergedModalProps}
          {...dialogContentProps}
          height={dialogProps.height}
          width={dialogProps.width}
          angularScope={$rootScope}
        >
        </LegacyDialog>
      </ThemeProvider>
    </Provider>
  );
};

const mapStateToProps = (state) => state.legacyDialog;
const mapDispatchToProps = { hideLegacyDialog };

export default connect(mapStateToProps, mapDispatchToProps)(LegacyDialogRoot);
